import './App.css';
import Main from './components/MainComponent/Main';
import './viewport_ios_fix.scss';

function App() {
  return (
    <div className="App">
      <Main></Main>
    </div>
  );
}

export default App;
